// import { APP_NAME, APP_OS_TYPE, APP_VERSION } from '@common/constants'
//TODO: need to add APP_OS_VERSION above later
import Cookies from 'js-cookie'

export type CookieKey = Record<string, Record<string, string> | string>
export const COOKIE_KEY: CookieKey = {
  DEVICE_ID: 'x-gm-device-id',
  APP_NAME: 'x-gm-app-name',
  APP_VERSION: 'x-gm-app-version',
  USER_INFO: 'FLO_UIF',
  ACCESS_TOKEN: 'FLO_AUT',
  REFRESH_TOKEN: 'FLO_RFT',
  IS_TPRIME: 'isTprime',
  SOCIAL_EMAIL: 'socialEmail',
  TPRIME_REDIRECT_URL: 'tprime-redirectUrl',
  APPLE_RETURN_URL: 'apple_return-url',
  AFFILIATE_TOKEN: 'affiliateToken',
  OS_TYPE_ENV: 'osType',
  REDIRECT_URL: 'redirectUrl',
  PROMOTION_ADID: 'ADID',
  CALL_ORIGIN: 'callOrigin',
  SOCIAL_REDIRECT_URL: 'socialRedirectUrl',
  SOCIAL_SIGNIN_DEVICE: 'socialSignInDevice',
  SOCIAL_SIGNIN_TYPE: 'socialSignInType',
  IS_APP: 'isApp',
  CLAUSE_LIST: 'clause',
  REDIRECT_AFLO: 'setRedirectToArtistFLO',
  GOOGLE_IAP_HISTORY: 'googleIAPHistory',
  ORIGIN: 'origin',
  ADID: 'ADID',
  PASS_ID: 'passId',

  /** mWeb에서만 사용하는 key */
  OS_TYPE: 'osType',
  MOBILE_DEVICE_ID: 'deviceId',
  ULIKE_BRIDGE: 'ulikeBridgeEnter',
  EXTERNAL: {
    AUTH_YN: 'externalAuthYn',
    FULL_PATH: 'externalFullPath',
    SERVICE_NAME: 'externalServiceName',
    REDIRECT_URI: 'externalRedirectUri',
    STATE: 'externalState',
    NON_FACE_TO_FACE_YN: 'nonFaceToFaceYn',
    PMBR_SCRB_ID: 'pmbrScrbId',
    TID_INTEGRATION_YN: 'tidIntegrationYn',
    TID_TOKEN: 'tidToken',
    PARTNER_MEMBER_ID: 'partnerMemberId',
    PARTY_ISSUE_TOKEN_TYPE: 'partyIssueTokenType',
  },
  INTRO_VIEW: 'intro-page-visual-mobile',
  IVI: {
    AUTH_YN: 'iviYn',
    FULL_PATH: 'iviFullPath',
  },
  INQUIRY_TYPE: 'inquiryType',

  /**  PCWeb에서만 사용하는 key */
  // OS_TYPE: 'x-gm-os-type',
  // OS_VERSION: 'x-gm-os-version',
  // SOCIAL_MEMBER_TYPE: 'social-member-type',
  // IDV_TYPE: 'idv_type',
  // IDV_BIRTH: 'idv_birth',
  // IDV_QUERY: 'idv_query',
  // PLAYER: 'FLO_PLY',
  // VOLUME: 'FLO_VOL',
  // INTRO_VIEW: 'intro-page-visual',
  // INTRO_PREVIOUS: 'intro-page-previous',
  // VALID_PLAYER_CODE: 'flo-fe-player-code',
  // FLOATING_DISABLED_COUNT: 'floating-disabled-count',
  // ALREADY_FLOATING_EXPOSED: 'already-floating-exposed',
  // PC_APP_VERSION: 'pc-app-version',
  // PC_APP_OS_TYPE: 'pc-app-os-type',
  // RECENT_RCMD_PANEL_ID: 'recentRcmdPanelId',
  // IS_SIGNUP_INPROGRESS: 'is-signup-inprogress',
  // NAVER_LOGIN_CANCELED: 'naverLoginCanceled',
  // NAVER_REROUTE_URL: 'naverRerouteUrl',
  // INFO_CONTROL_TID_LINK: 'info-control-tid-link',
  // SNS_SOCIAL_PWD: 'snsPwd',
  // CANCEL_VOUCHER: 'cancelVoucher',
}

interface CookieUtils {
  KEY: CookieKey
  get: (name: string | CookieKey) => string | undefined
  set: (name: string | CookieKey, value: string, option?: Cookies.CookieAttributes) => void
  pop: (name: string | CookieKey, option?: Cookies.CookieAttributes) => string | undefined
  delete: (name: string | CookieKey, option?: Cookies.CookieAttributes) => void
  isApp: () => boolean
  isPcWeb: () => boolean
  isLoggedIn: () => boolean
  getAffiliateToken: () => string | undefined

  /** mWeb에서만 사용하는 util */
  isIdea: () => boolean

  /** PCWeb에서만 사용하는 util */
  // initializeAppCookies: () => void
  // setAccessTokenCookie: (tokenString: string, options?: Cookies.CookieAttributes) => void
  // getAccessTokenCookie: () => string | null
  // removeAccessTokenCookie: () => void
  // removeCookiesByUserLogout: () => void
  // isNeedToSignIn: () => boolean
}

export const CookieUtils: CookieUtils = {
  KEY: COOKIE_KEY,
  get: (name) => {
    if (typeof name !== 'string') {
      return
    }
    try {
      return Cookies.get(name)
    } catch (error) {
      console.error('CookieUtils > get', error)
    }
  },
  set: (name, value, option?) => {
    try {
      if (typeof name !== 'string') {
        return
      }

      if (value) {
        if (option) {
          // .도메인 기준으로 쿠키 설정
          Cookies.set(name, value, option)
          // 일반 도메인 기준으로 쿠키 설정
          delete option.domain
          Cookies.set(name, value, option)
        } else {
          // .도메인 기준으로 쿠키 설정
          Cookies.set(name, value, { domain: '.music-flo.com' })
          // 일반 도메인 기준으로 쿠키 설정
          Cookies.set(name, value)
        }
        // 모든 경우에서 .도메인 값을 제거를 시도 (제거되면, 쿠키가 정리된것 이고, 제거되지 않아도 두 값이 같기에 get할때 이슈가 없음)
        Cookies.remove(name, { domain: '.music-flo.com' })
      }
    } catch (error) {
      console.error('CookieUtils > set', error)
    }
  },
  pop: (name, option) => {
    try {
      const value = CookieUtils.get(name)
      CookieUtils.delete(name, option)
      return value
    } catch (error) {
      console.error('CookieUtils > pop', error)
    }
  },
  delete: (name, option) => {
    try {
      if (typeof name !== 'string') {
        return
      }
      Cookies.remove(name, { domain: '.music-flo.com' })
      Cookies.remove(name)

      if (option !== undefined) {
        Cookies.remove(name, option)
      }
    } catch (error) {
      console.error('CookieUtils > delete', error)
    }
  },
  isApp() {
    return CookieUtils.get(COOKIE_KEY.IS_APP) === 'true'
  },
  isPcWeb() {
    return CookieUtils.get(COOKIE_KEY.OS_TYPE) === 'PC_WEB'
  },
  isLoggedIn() {
    return true
    // return !!CookieUtils.get(COOKIE_KEY.ACCESS_TOKEN)
  },
  getAffiliateToken() {
    return CookieUtils.get(COOKIE_KEY.AFFILIATE_TOKEN)
  },

  /** mWeb에서만 사용하는 util */
  isIdea() {
    return CookieUtils.get(COOKIE_KEY.INQUIRY_TYPE) === 'IDEA'
  },

  /** PCWeb에서만 사용하는 util */
  // initializeAppCookies() {
  //   this.set(PC_COOKIE_KEY.APP_NAME, APP_NAME)
  //   this.set(PC_COOKIE_KEY.APP_VERSION, APP_VERSION)
  //   this.set(PC_COOKIE_KEY.OS_TYPE, APP_OS_TYPE)
  //   // this.set(PC_COOKIE_KEY.OS_VERSION, APP_OS_VERSION)
  // },
  // setAccessTokenCookie(tokenString, options?) {
  //   try {
  //     if (!tokenString) {
  //       throw new Error('tokenString parameter 가 비었습니다.')
  //     }
  //     this.set(PC_COOKIE_KEY.ACCESS_TOKEN, tokenString, options || { expires: COOKIE_MAX_EXPIRED })
  //   } catch (error) {
  //     console.error('CookieUtils > setAccessToken', error)
  //   }
  // },
  // getAccessTokenCookie() {
  //   return this.get(PC_COOKIE_KEY.ACCESS_TOKEN) || null
  // },
  // removeAccessTokenCookie() {
  //   try {
  //     this.delete(PC_COOKIE_KEY.ACCESS_TOKEN)
  //   } catch (error) {
  //     console.error('CookieUtils > removeAccessTokenCookie', error)
  //   }
  // },
  // removeCookiesByUserLogout() {
  //   try {
  //     const keys = [
  //       PC_COOKIE_KEY.VALID_PLAYER_CODE,
  //       PC_COOKIE_KEY.ACCESS_TOKEN,
  //       PC_COOKIE_KEY.REFRESH_TOKEN,
  //       PC_COOKIE_KEY.USER_INFO,
  //       PC_COOKIE_KEY.PLAYER,
  //       PC_COOKIE_KEY.APP_NAME,
  //       PC_COOKIE_KEY.APP_VERSION,
  //       PC_COOKIE_KEY.OS_TYPE,
  //       PC_COOKIE_KEY.ALREADY_FLOATING_EXPOSED,
  //     ]
  //     keys.forEach((name) => {
  //       this.delete(name)
  //     })
  //   } catch (error) {
  //     console.error('CookieUtils > removeCookiesByUserlogout', error)
  //   }
  // },
  // isNeedToSignIn(){
  //   return !(this.get(PC_COOKIE_KEY.ACCESS_TOKEN) as string)
  // },
}

/** PCWeb에서만 사용하는 변수 */
const currentDate = new Date()
export const COOKIE_MAX_EXPIRED = new Date(currentDate.setMonth(currentDate.getMonth() + 1))
